import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { TimelineMax} from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
 
export interface SpinePlayConfig{
    name:string;

    track?:number;
    duration?:number;
    delay?:number;

    loop?:boolean;

    showOnEnd?:boolean;
}
 
export class SpinePlayer extends PIXI.Container{

    protected _tl:TimelineMax;
    protected _spine:PIXI.spine.Spine | undefined;
    protected _path:string;
    
    protected _anims:string[];

    constructor(spinePath:string){
        super();
        this.changeSpine(spinePath);
        this.visible = false;
    }

    public get spine():PIXI.spine.Spine{
        return this._spine!;
    }

    public get animations():string[]{
        return this._anims;
    }

    public get timeLine():TimelineMax{
        return this._tl;
    }

    public get isPlaying():boolean{
        return !!this._tl && this._tl.isActive();
    }

    public changeSpine(path:string):void{
        this._path = path;
        this.reset();

        this._anims = [];
        this._spine!.spineData.animations.forEach((d) => this._anims.push(d.name));
    }

    public play(conf:SpinePlayConfig):TimelineMax{
        this.reset();
        this._tl = Helper.timeLineKiller(this._tl,new TimelineMax({
            onStart:() => this.visible = true,
            onComplete:() => this.visible = !!conf.showOnEnd,
            repeat: !!conf.loop ? -1 : 0
        }));

        this.spine.state.addAnimation(conf.track === undefined ? 0: conf.track , conf.name , !!conf.loop, conf.delay === undefined ? 0 : conf.delay);
        const durr:number = conf.duration === undefined ? this.fetchDuration(conf.name) : conf.duration;
        this.spine.state.timeScale = this.fetchDuration(conf.name)/durr;
        this._tl.to(this, durr,{});
        return this._tl;
    }

    public stop():void{
        this._tl = Helper.timeLineKiller(this._tl);
        this.visible = false;
        this.reset();
    }

    public fetchDuration(name:string):number{
        for(let i:number = 0; i < this.spine.spineData.animations.length;i++){
            if(name ==this.spine.spineData.animations[i].name) 
                return this.spine.spineData.animations[i].duration;
        }
        return 0;
    }

    protected reset():void{
        if(this.spine){
            this.spine.destroy({children:true});
            this.removeChildren();
            delete this._spine;
        }
        this._spine = this.createSpine();
    }

    protected createSpine():PIXI.spine.Spine{
        const spine:PIXI.spine.Spine = this.addChild(new PIXI.spine.Spine(GameResources.getSpineAsset(this._path)));
        return spine;
    }

    public onResize?():void;
 }